'use client';

import { IFormsTemplate } from '@commenda/api';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

interface DeleteTemplateDialogProps {
  open: boolean;
  template: IFormsTemplate | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteTemplateDialog({
  open,
  template,
  onOpenChange,
  onConfirm,
}: DeleteTemplateDialogProps) {
  if (!open) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onOpenChange(false);
        }
      }}
    >
      <DialogContent>
        <DialogHeader className="flex flex-col gap-2 justify-start items-start">
          <DialogTitle>Delete Template?</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4 px-4">
          <div className="space-y-2">
            Are you sure you want to delete &quot;{template?.name}
            &quot;? This action cannot be undone.
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary">Cancel</Button>
          </DialogClose>
          <Button variant="destructive-primary" onClick={onConfirm}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
